// extracted by mini-css-extract-plugin
module.exports = {"container":"Section_container__3ztgI","actions":"Section_actions__2lXYZ","count":"Section_count__2kRtV","name":"Section_name__wtH1X"};